import { defineComponent as d, computed as o, openBlock as m, createElementBlock as f, normalizeClass as u, createVNode as p } from "vue";
import w from "./index60.js";
const b = ["data-name"], g = /* @__PURE__ */ d({
  __name: "BasePaginationArrow",
  props: {
    direction: { default: "left" },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(t, { emit: n }) {
    const a = t, r = n, i = (e) => {
      a.disabled || r("click", e);
    }, l = o(() => a.direction === "left" ? "arrow-backward" : "arrow-forward"), c = o(() => {
      const e = "pagination-arrow";
      return a.disabled ? `${e} pagination-arrow-disabled` : `${e} pagination-arrow-enabled`;
    }), s = o(() => a.disabled ? "var(--input-color-text-disable)" : "var(--icon-color-default)");
    return (e, _) => (m(), f("div", {
      class: u(c.value),
      onClick: i,
      "data-name": `Pagination/Arrow-${t.direction === "left" ? "Left" : "Right"}`
    }, [
      p(w, {
        name: l.value,
        size: "sm",
        color: s.value
      }, null, 8, ["name", "color"])
    ], 10, b));
  }
});
export {
  g as default
};
